import { StatusColor } from 'types/Status';
import { OperationStatus } from 'types/Operation';
import StatusColors from 'const/statusColors';

export const getDossierOperationStatusColor = (
  status: OperationStatus,
): StatusColor => {
  switch (status) {
    case OperationStatus.Litige:
    case OperationStatus.NonConforme:
    case OperationStatus.Incomplet:
    case OperationStatus.ActionEnCours:
    case OperationStatus.Refuse:
    case OperationStatus.ChantierNonConforme:
      return StatusColors.Rouge;

    case OperationStatus.BonPourPrime:
      return StatusColors.Vert;

    case OperationStatus.DossierEnCoursDeValidation:
    case OperationStatus.RemisAuControle:
      return StatusColors.BleuEntreprises;

    case OperationStatus.PreValide:
    case OperationStatus.Eligible:
      return StatusColors.Orange;

    case OperationStatus.Retire:
    case OperationStatus.AConfirmer:
    case OperationStatus.NonConfirme:
    case OperationStatus.Recommandations:
    case OperationStatus.Annule:
    default:
      return StatusColors.Gris;
  }
};
